import React, { useContext } from 'react';
import dayjs from 'dayjs';
import { BaseFilterProps } from '../../../../common/BaseFilter';
import { TranslationKey } from '../../../../../../../types/translation/TranslationKey';
import { t } from '../../../../../../../types/translation/Translator';
import DateTimeFilterDropdownContent from '../../../../DateTimeFilter/DropdownContent/DateTimeFilterDropdownContent';
import { UserContext } from '../../../../../../../context/UserContext';
import FilterDropdown from '../../../../common/FilterDropdown';
import { Icon } from '../../../../../../../ui/icons';
import { IconType } from '../../../../../../../ui/icons/Icon';

interface AssetCreatedAtFilterContentProps {
  props: BaseFilterProps;
}

export const AssetCreatedAtFilterContent = ({ props }: AssetCreatedAtFilterContentProps) => {
  const { locale } = useContext(UserContext);

  const text = (props: BaseFilterProps) => {
    if (!props.filterProps.assetCreatedAt) return t(TranslationKey.createdAt).singular.label;

    return `${new Date(props.filterProps.assetCreatedAt.start).toLocaleDateString(locale)} - ${new Date(
      props.filterProps.assetCreatedAt.end,
    ).toLocaleDateString(locale)}`;
  };

  const toInnerContent = (props: BaseFilterProps) => {
    return <div className='py-1 text-sm text-gray-500'>{text(props)}</div>;
  };

  const handleChange = (props: BaseFilterProps, start?: Date, end?: Date) => {
    if (!start || !end) {
      props.filterProps.assetCreatedAt = undefined;
    } else {
      if (!props.filterProps.assetCreatedAt) props.filterProps.assetCreatedAt = { start: start, end: end };
      props.filterProps.assetCreatedAt = { start: dayjs(start).startOf('day').toDate(), end: end };
    }
    props.setFilterProps({ ...props.filterProps });
  };

  return (
    <>
      <p className='mb-1 text-sm text-gray-900'>{`${t(TranslationKey.createdAt).singular.label}`}</p>
      <FilterDropdown
        width={'fit-content'}
        icon={<Icon type={IconType.wallet1} size={'size-5'} />}
        innerContent={toInnerContent(props)}
        dropdownContent={
          <DateTimeFilterDropdownContent
            key={'dateTimeFilterContent'}
            timeFrame={props.filterProps.timeFrame}
            color={'black'}
            onChange={(start, end) => handleChange(props, start, end)}
          />
        }
      />
    </>
  );
};
